import { Box, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { TextSerif } from "../TextSerif";

import type { MantineStyleProps } from "@mantine/core";
import type { FC } from "react";

type Props = {
  title?: string;
  description?: string;
  children?: React.ReactNode;
} & MantineStyleProps;

export const EmptyStateRevamped: FC<Props> = ({ title, description, children, ...props }) => {
  const { t } = useTranslation();

  const displayTitle = title ?? t("components.EmptyState.noResults");
  const displayDescription = description ?? t("components.EmptyState.clearYourFilters");

  return (
    <Box {...props}>
      <Text fz="1.25em" ta="center">
        {displayTitle}
      </Text>
      <TextSerif fz="sm" ta="center">
        {displayDescription}
      </TextSerif>
      {children}
    </Box>
  );
};
